import { render, staticRenderFns } from "./yexiangvip.vue?vue&type=template&id=932de5a2&scoped=true"
import script from "./yexiangvip.vue?vue&type=script&lang=js"
export * from "./yexiangvip.vue?vue&type=script&lang=js"
import style0 from "./yexiangvip.vue?vue&type=style&index=0&id=932de5a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "932de5a2",
  null
  
)

export default component.exports